import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "./api";
import { useAuth } from "./auth";

const FavCtx = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    if (!user) { setIds(new Set()); return; }
    try {
      const { data } = await api.get("/favorites/ids");
      setIds(new Set(data));
    } catch (err) {
      console.error("[favorites] refresh failed", err);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isFav = useCallback((id) => ids.has(id), [ids]);

  const toggle = useCallback(async (id) => {
    if (!user) return { needAuth: true };
    const next = new Set(ids);
    if (next.has(id)) {
      next.delete(id);
      setIds(next);
      try {
        await api.delete(`/favorites/${id}`);
      } catch (err) {
        console.error("[favorites] delete failed", err);
        setIds(ids);
      }
    } else {
      next.add(id);
      setIds(next);
      try {
        await api.post(`/favorites/${id}`);
      } catch (err) {
        console.error("[favorites] add failed", err);
        setIds(ids);
      }
    }
    return {};
  }, [ids, user]);

  const value = useMemo(
    () => ({ ids, isFav, toggle, refresh }),
    [ids, isFav, toggle, refresh]
  );

  return <FavCtx.Provider value={value}>{children}</FavCtx.Provider>;
}

export function useFavorites() { return useContext(FavCtx); }
